export let ACCESS_ROLE = 'patron';

export const setAccessRoleGlobale = (r) => {
  ACCESS_ROLE = r || 'patron';
};

export let NOTIF_N = 0;

export const setNotifN = (n) => {
  NOTIF_N = n || 0;
};

export let PERM_STOCK = {};

export const setPermStock = (p) => {
  PERM_STOCK = p || {};
};

// Réglages → Accès → « Droits — attestations de l'entreprise » : par rôle.
export let PERM_ATTESTATIONS = {};

export const setPermAttestations = (p) => {
  PERM_ATTESTATIONS = p || {};
};

/**
 * Le rôle voit-il les attestations de l'entreprise (RC, registre du commerce,
 * poursuites…), les joint-il à une offre, les envoie-t-il ? Le patron et la
 * comptable toujours ; le technicien et la secrétaire si le patron le leur
 * donne ; l'ouvrier jamais. Le serveur applique la même règle.
 *
 * @param {object} [perms] réglage `soc.permAttestations`, par rôle
 * @param {string} [role] rôle du compte
 * @returns {boolean} vrai si la carte et les cases d'envoi paraissent
 */
export const voitLesAttestations = (perms = PERM_ATTESTATIONS, role = ACCESS_ROLE) => {
  if (role === 'patron' || role === 'comptable') return true;
  if (role === 'technicien' || role === 'directeur' || role === 'secretaire')
    return (perms || {})[role] === true;
  return false;
};

export let ACCESS_PERMS = {};

export const setAccessPerms = (p) => {
  ACCESS_PERMS = p || {};
};

export const ROLE_LABEL = {
  patron: 'Patron / Direction',
  technicien: "Technicien / Chef d'équipe",
  directeur: 'Directeur des travaux',
  comptable: 'Comptable / Fiduciaire',
  secretaire: 'Secrétaire',
  ouvrier: 'Employé',
  invite: 'Invité (démo)',
};

export const ROLE_ICON = {
  patron: '♛',
  technicien: '⚙',
  directeur: '🧭',
  comptable: '∑',
  secretaire: '✎',
  ouvrier: '⚒',
  invite: '👤',
};

export const ROLE_DESC = {
  patron:
    "Accès complet : tout voir et tout gérer, y compris le chiffre d'affaires et le bénéfice.",
  technicien:
    'Offres, factures, dépenses, suivi des chantiers et des paiements, clients, RDV, équipe. Sans la marge ni le bénéfice.',
  directeur:
    'Toutes les équipes et tous les chantiers, au-dessus des techniciens. Le reste se règle dans Réglages → Accès.',
  comptable:
    'Accès à tout : comptabilité, TVA, factures, paie, dépenses, stock, marge et bénéfice. Les réglages restent au patron.',
  secretaire:
    'Offres, factures, dépenses, suivi des chantiers et des paiements, clients, RDV, équipe. Sans la marge ni le bénéfice.',
  ouvrier:
    'Son espace perso uniquement : pointage, rapports, photos, sa fiche de salaire, ses vacances.',
  invite: 'Exploration de la démo.',
};

const BUREAU_SANS_BENEFICE = [
  'accueil',
  'devis',
  'soumissions',
  'chantiers',
  'equipe',
  'factures',
  // Les dépenses et les frais, qu'ils saisissent : le patron peut les leur
  // fermer dans Réglages → Accès.
  'depenses',
  'ventes',
  'stock',
  'remises',
  'commandes',
  'livraisons',
  'ouverture',
  'planning',
  'clients',
  'rdv',
  // Le bon d'achat de matériaux : envoyer un employé chez un fournisseur.
  'bonsachat',
  // Envoyer à l'équipe : message, rendez-vous, plan, chantier du jour,
  // consigne ou document, à un employé, plusieurs ou toute l'équipe d'un chantier.
  'envoyer',
  // Courrier et décharge : rangés au classeur, et le patron reçoit un e-mail
  // à chaque pièce écrite ou envoyée par le bureau.
  'courrier',
  'decharge',
  'notifs',
  'archives',
  'abonnement',
  'partage',
  'support',
  'plus',
];

export const ROLE_ROUTES = {
  patron: null,
  // La comptable a accès à tout, comme le patron, sauf l'administration de la
  // société qui reste au patron : les réglages (accès, invitations, comptes)
  // et le journal des connexions.
  comptable: [
    'accueil',
    'devis',
    'soumissions',
    'chantiers',
    'equipe',
    'factures',
    'compta',
    'depenses',
    'envois',
    'ventes',
    'stock',
    'articles',
    'remises',
    'commandes',
    'livraisons',
    'ouverture',
    'planning',
    'clients',
    'rdv',
    'notifs',
    'recherche',
    'courrier',
    'bonsachat',
    'modeles',
    'suggestions',
    'securite',
    'bonc',
    'stats',
    'import',
    'decharge',
    'gps',
    'outils',
    'formation',
    'archives',
    'abonnement',
    'partage',
    'support',
    'aide',
    'plus',
  ],
  // Le technicien et la secrétaire ont les mêmes accès : offres, factures,
  // dépenses, suivi des chantiers et des paiements — sans marge ni bénéfice.
  technicien: BUREAU_SANS_BENEFICE,
  directeur: BUREAU_SANS_BENEFICE,
  secretaire: BUREAU_SANS_BENEFICE,
  // L'accueil est le tableau de bord de l'entreprise : chiffre d'affaires,
  // offres en attente, factures en retard. Rien de tout cela n'est servi a un
  // ouvrier, qui n'y lisait donc que des zeros et des tuiles sans issue. Son
  // ecran d'accueil est son espace.
  //
  // La page Sécurité lui est ouverte, réduite au changement de mot de passe :
  // le message d'invitation l'y renvoie, et un ouvrier invité par e-mail doit
  // pouvoir remplacer le mot de passe provisoire qu'on lui a transmis.
  // « signaux » : sa cloche — messages, rendez-vous, plans, documents du bureau.
  ouvrier: ['ouvrier', 'signaux', 'gps', 'planning', 'partage', 'support', 'plus', 'securite'],
};

export const ROLE_NAV = {
  comptable: ['accueil', 'devis', 'chantiers', 'factures', 'plus'],
  technicien: ['accueil', 'devis', 'chantiers', 'factures', 'plus'],
  directeur: ['accueil', 'devis', 'chantiers', 'factures', 'plus'],
  secretaire: ['accueil', 'devis', 'chantiers', 'factures', 'plus'],
  ouvrier: ['ouvrier', 'plus'],
};

/**
 * La barre du bas des mêmes rôles dans l'univers Magasin : les ventes y
 * tiennent la place des chantiers. Sans elle, la liste du bâtiment filtrait
 * la barre du magasin, et le technicien, la secrétaire ou le comptable d'un
 * magasin perdaient « Ventes ».
 */
export const ROLE_NAV_MAG = {
  comptable: ['accueil', 'ventes', 'devis', 'factures', 'plus'],
  technicien: ['accueil', 'ventes', 'devis', 'factures', 'plus'],
  directeur: ['accueil', 'ventes', 'devis', 'factures', 'plus'],
  secretaire: ['accueil', 'ventes', 'devis', 'factures', 'plus'],
  ouvrier: ['ouvrier', 'plus'],
};

/**
 * Les entrées de la barre du bas ouvertes au rôle courant, dans un univers.
 *
 * <p>Chaque entrée passe aussi par les droits du rôle (`roleCan`) : une page
 * que le patron a fermée dans « Réglages → Accès » — les ventes, les
 * chantiers — ne garde pas un bouton qui ramènerait à l'accueil.
 *
 * @param {Array<{id: string}>} base barre de l'univers (`NAV_BAT`, `NAV_MAG`…)
 * @param {boolean} mag vrai dans l'univers Magasin
 * @returns {Array<{id: string}>} les entrées retenues
 */
export const navDuRole = (base, mag) => {
  const permises = (mag ? ROLE_NAV_MAG : ROLE_NAV)[ACCESS_ROLE];
  return base.filter((it) => (!permises || permises.includes(it.id)) && roleCan(it.id));
};

export const PERM_ROUTE = {
  devis: 'offres',
  soumissions: 'offres',
  factures: 'factures',
  chantiers: 'chantiers',
  equipe: 'equipe',
  ventes: 'ventes',
  stock: 'ventes',
  remises: 'ventes',
  depenses: 'depenses',
  clients: 'clients',
  rdv: 'rdv',
  planning: 'rdv',
  envoyer: 'equipe',
};

/**
 * Ecran d'ouverture du role courant, et repli quand la route demandee lui est
 * fermee. L'accueil sert a la plupart ; ceux qui n'y ont pas droit tombent sur
 * la premiere route qui leur revient.
 *
 * @returns {string} la route de repli
 */
export const routeParDefaut = () => {
  const autorisees = ROLE_ROUTES[ACCESS_ROLE];
  if (!autorisees || autorisees.includes('accueil')) return 'accueil';
  return autorisees[0];
};

/**
 * Un droit de l'écran « Accès » pour un rôle, tel que la société l'a réglé.
 *
 * Le patron a tout ; l'ouvrier n'a pas de réglage, ses restrictions sont
 * ailleurs. Pour les autres, une clé absente vaut la valeur par défaut de
 * l'écran — ouvert, sauf indication contraire. Le serveur applique la même
 * règle (`DroitsSociete`) : ce que l'écran ne demande pas, l'API ne le sert
 * pas non plus.
 *
 * @param {string} cle clé du réglage (`offres`, `factures`, `paiement`…)
 * @param {object|null} soc société, avec son sac `acces`
 * @param {string} role rôle du compte
 * @param {boolean} [defaut] valeur quand le réglage est absent
 * @returns {boolean} vrai si le droit est ouvert
 */
export const ecranOuvert = (cle, soc, role, defaut = true) => {
  if (role === 'patron' || role === 'ouvrier') return true;
  const valeur = soc?.acces?.[role]?.[cle];
  if (valeur === undefined || valeur === null) return defaut;
  return valeur !== false;
};

/**
 * Marquer une facture payée, encaisser un acompte, rembourser.
 *
 * @returns {boolean} vrai si le rôle courant encaisse
 */
/**
 * Le rôle courant voit-il le chiffre d'affaires et le bénéfice ? Le patron et
 * la comptable, oui ; le technicien et la secrétaire, seulement si le patron
 * leur a donné le droit « bénéfice ».
 *
 * @returns {boolean} vrai si les montants de la direction peuvent paraître
 */
export const voitLeBenefice = () =>
  ACCESS_ROLE === 'patron' ||
  ACCESS_ROLE === 'comptable' ||
  !!(ACCESS_PERMS[ACCESS_ROLE] && ACCESS_PERMS[ACCESS_ROLE].benefice);

// Les dépenses d'un chantier (matériel acheté, factures des fournisseurs) et
// le suivi de sa facturation : la secrétaire et le technicien les font, c'est
// leur travail. La marge et le bénéfice restent à voitLeBenefice().
export const suitLesDepenses = () =>
  voitLeBenefice() ||
  ACCESS_ROLE === 'secretaire' ||
  ACCESS_ROLE === 'technicien' ||
  ACCESS_ROLE === 'directeur';

/**
 * Les prix des offres et des avenants (Réglages → Accès, « Prix des offres »).
 * Ouverts par défaut, comme avant ; fermés, le rôle voit les travaux et les
 * quantités. Le serveur applique la même règle.
 *
 * @returns {boolean} vrai si le rôle courant lit les prix des offres
 */
export const voitLesPrixDesOffres = () => {
  if (ACCESS_ROLE === 'patron' || ACCESS_ROLE === 'comptable') return true;
  const p = ACCESS_PERMS[ACCESS_ROLE];
  return !p || p.prixOffres !== false;
};

export const peutEncaisser = () => {
  if (ACCESS_ROLE === 'patron' || ACCESS_ROLE === 'comptable') return true;
  const p = ACCESS_PERMS[ACCESS_ROLE];
  return !p || p.paiement !== false;
};

export const roleCan = (route) => {
  if (
    (route === 'stock' || route === 'articles') &&
    ACCESS_ROLE !== 'patron' &&
    ACCESS_ROLE !== 'comptable' &&
    !PERM_STOCK[ACCESS_ROLE]
  )
    return false;
  const a = ROLE_ROUTES[ACCESS_ROLE];
  if (a && !a.includes(route)) return false;
  const _p = ACCESS_PERMS[ACCESS_ROLE];
  if (_p) {
    const _k = PERM_ROUTE[route];
    if (_k && _p[_k] === false) return false;
  }
  return true;
};
